import type { Conversation, Message } from './chatStore'

/** QA #110: mensagem do usuário é atividade; só avança `updatedAt`, nunca recua. */
export function bumpActivity(conversations: Conversation[], message: Message): Conversation[] {
  if (message.role !== 'user') return conversations
  return conversations.map((c) =>
    c.id === message.conversationId && c.updatedAt < message.timestamp
      ? { ...c, updatedAt: message.timestamp }
      : c,
  )
}
